/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var parsleyUtil = require('common/util/parsleyUtil');
var showErrorMessage = require('common/util/showErrorMessage');

var getApplicationInvoiceItems = require('../../util/getApplicationInvoiceItems');

var SubmitConsumerDiscountRenewalApplication = require('../../services/SubmitConsumerDiscountRenewalApplication');
var GetTaskData = require('common/services/GetTaskData');

var tmplConsumerDiscountRenewalAffirmationSectionView = require('./ConsumerDiscountRenewalAffirmationSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConsumerDiscountRenewalAffirmationSectionView,

  className: 'consumer-discount-renewal-affirmation-section-view',

  ui: {
    affirmationForm: '.affirmation-form',
    validationErrors: '.validation-errors',
    validationErrorSections: '.validation-error-sections',
    submit: '.submit'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function(e) {
    if (this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand') {
      Syphon.deserialize(this, this.model.get('renewalData'));
    }
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var taskId = self.model.get('taskId');
    if (!_.isUndefined(taskId)) {
      GetTaskData(taskId).done(function(taskData) {
        if (taskData.state === 'COMPLETED') {
          showErrorMessage({
            errorCode: 'application.already.submitted',
            errorTitle: 'Application Already Submitted',
            errorMessage: 'This application has already been submitted.'
          });
        } else {
          self.submitApplication(e);
        }
      });
    } else {
      self.submitApplication(e);
    }
  },

  submitApplication: function(e) {
    var self = this;
    this.ui.validationErrors.hide();

    this.sideNavView
      .validateAll({ type: 'submit' })
      .done(function() {
        var l = Ladda.create(self.ui.submit[0]);
        l.start();
        var rawFormData = self.sideNavView.getFormData();
        var formData = {
          applicationId: self.model.get('applicationDetails').applicationId,
          generalDetails: rawFormData.consumerDiscountRenewalGeneralDetails,
          certifyCapital: rawFormData.consumerDiscountRenewalCertifyCapital,
          branchLicenses: rawFormData.consumerDiscountRenewalBranches,
          affirmation: rawFormData.consumerDiscountRenewalAffirmation
        };
        SubmitConsumerDiscountRenewalApplication(formData)
          .done(function() {
            var applicationDetails = self.model.get('applicationDetails');
            applicationDetails.isResubmission = self.model.get('renewalData').isResubmission;
            var countOfRenewingBranches = _.where(formData.branchLicenses, { isRenewing: true }).length;
            var invoiceItems = getApplicationInvoiceItems(applicationDetails, countOfRenewingBranches);
            Radio.channel('nd:submit-application').trigger('proceed-to-payment', invoiceItems);
            l.stop();
          })
          .fail(function() {
            l.stop();
          });
      })
      .fail(function() {
        var errors = self.sideNavView.getSectionTitlesWithErrors();
        self.ui.validationErrorSections.empty();
        self.ui.validationErrorSections.append(errors.join('<br/>'));
        self.ui.validationErrors.show();
      });
  },

  validate: function(config) {
    if (config.type === 'save') {
      parsleyUtil.disableRequiredValidation(this.ui.affirmationForm);
    } else {
      parsleyUtil.enableRequiredValidation(this.ui.affirmationForm);
    }
    return this.ui.affirmationForm.parsley().whenValidate();
  },

  getFormData: function() {
    return Syphon.serialize(this);
  }
});
